<div class="form-header">
  <div class="form-header-title" >{{ title }} <span class="optional" *ngIf="showoptional">Optional</span><span class="optional" *ngIf="showOptionalWithBrackets">(Optional)</span>
    <span *ngIf="tooltiptxt" [ngbTooltip]=tooltiptxt placement="right" class="info">
      <em
      class="fa fa-info-circle info-icon"
    ></em></span>
  </div>
  <div class="spacer"></div>
  <ng-content></ng-content>
</div>
